import { router } from 'src';

import { Api } from 'src/api/@generated/backend';

import { AuthenticationError } from 'src/model/authentication-error';
import { NavigationService } from 'src/services/navigation-service';
import { StateService } from 'src/services/state-service';

export const api = new Api({
  baseURL: '/',
  // Uncomment adapter if want to use mock data
  // adapter: createMockDataAdapter,
});

api.instance.interceptors.request.use((request) => {
  const token: string | undefined = StateService.getAccessToken();

  if (token && request.headers) {
    request.headers.Authorization = `Bearer ${token}`;
  }

  return request;
});

api.instance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 401) {
      router.navigate(NavigationService.ERROR_SESSION_EXPIRED);
      return Promise.reject(new AuthenticationError('Unauthorized'));
    }

    return Promise.reject(error.response);
  },
);
